import React from 'react';
import { ContactForm } from './ContactForm';
import { ShieldCheck } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-white pt-16 pb-12" style={{
    overflow: 'visible'
  }} data-id="element-42">
      {/* Geometric SVG background - contained via positioning, no overflow clipping */}
      <div className="absolute inset-0 pointer-events-none" style={{
      overflow: 'visible'
    }} data-id="element-43">
        <svg className="absolute top-0 left-0 w-full h-full pointer-events-none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" viewBox="0 0 1440 700" data-id="element-44">
          {/* Large diagonal band */}
          <polygon points="0,0 1440,0 1440,120 0,220" fill="#F8F9FB" data-id="element-45" />
          {/* Orange accent triangle - top right */}
          <polygon points="900,0 1440,0 1440,220" fill="#E8722A" opacity="0.06" data-id="element-46" />
          {/* Navy accent triangle - left */}
          <polygon points="0,100 0,450 300,250" fill="#1B2A4A" opacity="0.04" data-id="element-47" />
          {/* Subtle orange diamond - center */}
          <polygon points="700,80 820,180 700,280 580,180" fill="#E8722A" opacity="0.05" data-id="element-48" />
          {/* Thin diagonal lines */}
          <line x1="0" y1="340" x2="1440" y2="140" stroke="#E8722A" strokeWidth="1" opacity="0.08" data-id="element-49" />
          <line x1="0" y1="380" x2="1440" y2="180" stroke="#1B2A4A" strokeWidth="0.5" opacity="0.06" data-id="element-50" />
          {/* Dotted grid pattern - right side */}
          {Array.from({
          length: 8
        }).map((_, row) => Array.from({
          length: 6
        }).map((_, col) => <circle key={`dot-${row}-${col}`} cx={1000 + col * 30} cy={300 + row * 30} r="1.5" fill="#1B2A4A" opacity="0.08" data-id="element-51" />))}
          {/* Dotted grid pattern - left side */}
          {Array.from({
          length: 5
        }).map((_, row) => Array.from({
          length: 4
        }).map((_, col) => <circle key={`dot2-${row}-${col}`} cx={80 + col * 30} cy={480 + row * 30} r="1.5" fill="#E8722A" opacity="0.1" data-id="element-52" />))}
          {/* Large circle outline - decorative */}
          <circle cx="1300" cy="500" r="160" fill="none" stroke="#E8722A" strokeWidth="1" opacity="0.07" data-id="element-53" />
          <circle cx="1300" cy="500" r="120" fill="none" stroke="#E8722A" strokeWidth="0.5" opacity="0.05" data-id="element-54" />
          {/* Small geometric accents */}
          <rect x="200" y="50" width="40" height="40" rx="4" fill="none" stroke="#1B2A4A" strokeWidth="1" opacity="0.06" transform="rotate(15 220 70)" data-id="element-55" />
          <rect x="1100" y="400" width="30" height="30" rx="3" fill="#E8722A" opacity="0.04" transform="rotate(30 1115 415)" data-id="element-56" />
          {/* Chevron / arrow shapes echoing the Keena logo */}
          <polyline points="450,520 480,490 510,520" fill="none" stroke="#E8722A" strokeWidth="1.5" opacity="0.1" data-id="element-57" />
          <polyline points="460,540 480,520 500,540" fill="none" stroke="#E8722A" strokeWidth="1" opacity="0.07" data-id="element-58" />
        </svg>
      </div>

      {/* Bottom fade to white */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-b from-transparent to-white pointer-events-none z-[5]" data-id="element-59"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-60">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-61">
          {/* Left Content */}
          <div className="max-w-2xl" data-id="element-62">
            <h1 className="sm:text-4xl lg:text-5xl font-extrabold text-navy mb-6 text-[48px]" data-id="element-63">
              Simplify HR, Payroll & Compliance with One{' '}
              <span className="text-orange" data-id="element-64">PEO</span> Partner
            </h1>

            <p className="text-lg sm:text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-65">
              All-in-one PEO solutions that help you manage your team, reduce
              risk, and focus on growing your business.
            </p>

            <div className="inline-flex items-center space-x-2 bg-white/80 backdrop-blur-sm border border-gray-200 rounded-full py-2 px-4 shadow-sm mb-10" data-id="element-66">
              <ShieldCheck className="w-5 h-5 text-orange" data-id="element-67" />
              <span className="text-sm font-semibold text-navy" data-id="element-68">
                Trusted by businesses across Upstate New York for 40+ years
              </span>
            </div>

            <img src="https://cdn.magicpatterns.com/uploads/n3iQnNfZpJe6nXeAbJ6aJp/keena_better_quality_bg.webp" alt="Keena PEO dashboard preview on laptop and mobile" className="w-full max-w-xl h-auto" data-id="element-69" />
          </div>

          {/* Right Content - Form */}
          <div className="lg:pl-8" data-id="element-70">
            <ContactForm title="Contact Keena" data-id="element-71" />
          </div>
        </div>
      </div>
    </section>;
}